export const isLegacyProductId = (value = '') => /^\d+$/.test(String(value || '').trim());

export const getProductSlug = (product) => {
  const slug = String(product?.slug || '').trim();

  if (slug) {
    return slug;
  }

  const fallbackId = product?._id ?? product?.id;
  return fallbackId ? String(fallbackId) : '';
};

export const buildProductPath = (productOrSlug) => {
  const pathSegment =
    typeof productOrSlug === 'object' && productOrSlug !== null
      ? getProductSlug(productOrSlug)
      : String(productOrSlug || '').trim();

  return `/product/${encodeURIComponent(pathSegment)}`;
};
